import Auth from '../modules/Authentication'
import { apiUrl } from '../variables'
import { handleErrors, handleResponse } from '../modules/Utils'

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
}
const auth = new Auth()

export const TaskSystemApi = {
  list: () => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/?select=*`, { headers }).then(handleErrors).then(handleResponse)
  },
  read: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/${key}`, { headers }).then(handleErrors).then(handleResponse)
  },
  create: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  update: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },
  remove: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/`, {
      headers: headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  operation: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  changeState: (data) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/state`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  },

  getLinesByTask: (key) => {
    headers['authorization'] = `Bearer ${auth.getAccessToken()}`
    return fetch(`${apiUrl}task/${key}/lines`, { headers }).then(handleErrors).then(handleResponse)
  },

  lines: {
    list: () => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}task/lines/`, { headers }).then(handleErrors).then(handleResponse)
    },
    create: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}task/lines/`, {
        headers: headers,
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    update: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}task/lines/`, {
        headers: headers,
        method: 'PATCH',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
    remove: (data) => {
      headers['authorization'] = `Bearer ${auth.getAccessToken()}`
      return fetch(`${apiUrl}task/lines/`, {
        headers: headers,
        method: 'DELETE',
        body: JSON.stringify(data),
      })
        .then(handleErrors)
        .then(handleResponse)
    },
  },
}
